import { SvgIcon, SvgIconProps } from "@material-ui/core";
import * as React from "react";

export const SparkleIcon = (props: SvgIconProps) => {
    const { htmlColor = "#5C4FB0", viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon
            width="24"
            height="24"
            viewBox={viewBox}
            htmlColor={htmlColor}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.1489 7.81556L16 10.3333L14.8511 7.81556L12.3333 6.66667L14.8511 5.51778L16 3L17.1489 5.51778L19.6667 6.66667L17.1489 7.81556ZM9.88889 7.88889L11.4167 11.25L14.7778 12.7778L11.4167 14.3056L9.88889 17.6667L8.36111 14.3056L5 12.7778L8.36111 11.25L9.88889 7.88889ZM14.94 19.94L14 22L13.06 19.94L11 19L13.06 18.06L14 16L14.94 18.06L17 19L14.94 19.94Z"
            />
        </SvgIcon>
    );
};
